import { Account, AccountType } from 'src/models';

export enum HeaderMenuItemKey {
  MyAccount = 'MyAccount',
  MoneyTransfers = 'MoneyTransfers',
  AccountStatus = 'AccountStatus',
  AccountStatements = 'AccountStatements',
  ChangeEmail = 'ChangeEmail',
  IndicationsOfInterest = 'IndicationsOfInterst',
}

export interface HeaderMenuItem {
  key: HeaderMenuItemKey;
  name: string;
  path: (id?: string) => string;
  isVisible: (param: { type?: AccountType; isEntityAccountTypeActive?: boolean }) => boolean;
}

export const accountSettingMenuItemList: HeaderMenuItem[] = [
  {
    key: HeaderMenuItemKey.MoneyTransfers,
    name: 'Money Transfers & Preferences',
    path: (id?: string) => `/accounts/${id}/money-transfers`,
    isVisible: ({ type, isEntityAccountTypeActive = false }) => (type?.isEntity ? isEntityAccountTypeActive : true),
  },
  {
    key: HeaderMenuItemKey.AccountStatus,
    name: 'Account Status',
    path: (id?: string) => `/accounts/${id}/account-status`,
    isVisible: () => true,
  },
  {
    key: HeaderMenuItemKey.AccountStatements,
    name: 'Statements & Documents',
    path: (id?: string) => `/accounts/${id}/statements`,
    isVisible: ({ type, isEntityAccountTypeActive = false }) => (type?.isEntity ? isEntityAccountTypeActive : true),
  },
];

export const getAccountSettingMenuItemList = (account?: Account): HeaderMenuItem[] => {
  if (!account?.accountId) {
    return [];
  }

  return accountSettingMenuItemList.filter(item =>
    item.isVisible({ type: account.type, isEntityAccountTypeActive: account.isEntityAccountTypeActive }),
  );
};

export const userSettingMenuItemList: HeaderMenuItem[] = [
  {
    key: HeaderMenuItemKey.IndicationsOfInterest,
    name: 'Indications of Interest',
    path: () => `/user/indications-of-interest`,
    isVisible: () => true,
  },
  {
    key: HeaderMenuItemKey.ChangeEmail,
    name: 'Change Email Address & Phone Number',
    path: () => '/user/settings',
    isVisible: ({ type, isEntityAccountTypeActive = false }) => (type?.isEntity ? isEntityAccountTypeActive : true),
  },
];

export const getUserSettingMenuItemList = (account?: Account): HeaderMenuItem[] => {
  if (!account?.accountId) {
    return [
      {
        key: HeaderMenuItemKey.IndicationsOfInterest,
        name: 'Indications of Interest',
        path: () => `/user/indications-of-interest`,
        isVisible: () => true,
      },
    ];
  }

  return userSettingMenuItemList.filter(item =>
    item.isVisible({ type: account.type, isEntityAccountTypeActive: account.isEntityAccountTypeActive }),
  );
};
